"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgArrowBold(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 0 16 24" }, props),
        React.createElement("path", { d: "M4 12.119L12 4l8 8.119-2.8 2.841-3.2-3.245V20h-4v-8.287L6.8 14.96 4 12.12z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('ArrowBold')(SvgArrowBold);
//# sourceMappingURL=ArrowBold.js.map